import React from 'react'
import ReactDOM from 'react-dom'
import NetPoints from './components/NetPoints'
import Overview from './components/Overview'
import eventBus from '../../../../../../util/eventBus'
import styles from './index.css'

/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function MyComponent (model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----init', this.model, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update', this.model, props)
      eventBus.pub(this.model, 'update', props.data)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
      ReactDOM.unmountComponentAtNode(this.model.dom)
    }
  }

  var setHtml = function (model, primaryProps) {
    KDApi.loadFile('./css/index.css', model, () => {
      class Root extends React.Component {
        constructor(props) {
          super(props)
          this.getOtherData = this.getOtherData.bind(this)
          this.networkKey = ''
          this.state = {
            nodes: [],
            result: {}
          }
        }

        getLangMsg(key) {
          return KDApi.getLangMsg(model, key)
        }

        getOtherData(value) {
          this.networkKey = value
          this.props.model.invoke('serviceCenterNameSelect', JSON.stringify({
            serviceCenterNumber: value
          }))
        }
        componentDidMount() {
          console.log('-------mount---------')
          this.props.customProps.data.length && this.getOtherData(this.props.customProps.data[0].number)
          
          this.updateSub = eventBus.sub(this.props.model, 'update', (updateProps) => {
            const { nodes, ...res } = updateProps
            if (nodes) {
              this.setState({
                result: {
                  ...res,
                  runningDays: Math.ceil((Date.now() - res.startTime * 1000) / (24 * 60 * 60 * 1000))
                },
                nodes
              })
            }            
          })
        }
 
        componentWillUnmount() {
          eventBus.unsub(this.updateSub)
        }
        render () {
          const { result, nodes } = this.state
          return (
            <div className={styles['wrapper-outer']}>
              <Overview model={this.props.model} list={this.props.customProps.data} result={result} onSelectChange={this.getOtherData} getLangMsg={ this.getLangMsg }/>
              <NetPoints model={this.props.model} customProps={nodes} networkKey={this.networkKey} getLangMsg={ this.getLangMsg }/>
            </div>                    
          )
        }
      }
      ReactDOM.render(<Root model={model} customProps={primaryProps} />, model.dom)
    })
  }
  // 注册自定义组件
  KDApi.register('blockchainNodes', MyComponent, {
    isMulLang: true
  })
})(window.KDApi)